import { ColumnsType } from "antd/lib/table";
import { ProductDetailDto } from "../../api";
import { CrudTableWrapperProps } from "digimuth-components/dist/components/crudTable/crudTable";
import { CrudTable, nameof } from "digimuth-components/dist";

export default function ProductDetailsList(props: CrudTableWrapperProps<ProductDetailDto>) {
    const columns: ColumnsType<ProductDetailDto> = [
        {
            key: nameof<ProductDetailDto>("header"),
            dataIndex: nameof<ProductDetailDto>("header"),
            title:"Nagłówek"
        },
        {
            key: nameof<ProductDetailDto>("content"),
            dataIndex: nameof<ProductDetailDto>("content"),
            title:"Tekst"
        },
    ];

    return <>
        <CrudTable
            data={props.data}
            onAddClicked={props.onAddClicked}
            onEditClicked={props.onEditClicked}
            onDeleteClicked={props.onDeleteClicked}
            isLoading={props.isLoading}
            columns={columns}
            addButtonTitle={"+ Dodaj nową sekcję"}
            editButtonTitle={"Edytuj"}
            deleteButtonTitle={"Usuń"}
            deleteConfirmMessage={"Czy na pewno usunąć ten wpis?"}
            cancelButtonTitle={"Anuluj"}
        />
    </>
}
